import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MediaWatcherService } from '@core/services/media-watcher';
import { BxNavigationService, BxVerticalNavigationComponent } from '@core/components/navigation';
import { Navigation } from 'app/configuration/navigation/navigation.types';
import { NavigationService } from 'app/configuration/navigation/navigation.service';
import { ManageUserService } from 'app/layout/components-common/user/manage-user.service';
import { environment } from "environments/environment";
import { manageStorageService } from '@core/services/manage-storage/manage-storage.service';
import { SharedService, SharedUserDataService } from '@core/services/shared';
import { UtilsService } from '@core/services/utils';

@Component({
  selector: "modern-layout",
  templateUrl: "./modern.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class ModernLayoutComponent implements OnInit, OnDestroy {
  isScreenSmall: boolean;
  navigation: Navigation;
  version: string = environment.version.replace(/[*+?^${}()|[\]\\]/g, "");
  enviromentLabel: string = environment.envLabel || "";
  private _unsubscribeMdrn: Subject<boolean> = new Subject();

  // Datos del contrato seleccionado
  clientName: string;
  maskedContract: string;

  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _navigationService: NavigationService,
    private _mediaWatcherService: MediaWatcherService,
    private _bxNavigationService: BxNavigationService,
    private _manageUserService: ManageUserService,
    private _mStorage: manageStorageService,
    private _shrdInfo: SharedService,
    private _shrdUsrInfo: SharedUserDataService,
    private _utilS: UtilsService
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // Verifica si estamos en una de las rutas donde queremos ocultar el footer
  get hideFooter(): boolean {
    return ['/operaciones/mercadoCapitales', '/operaciones/fondosInversion'].includes(this._router.url);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {


    // ✅ Suscribirse a los cambios en el contrato seleccionado
    this._shrdUsrInfo.getDataUserSession$
      .pipe(
        filter((value) => value !== null),
        takeUntil(this._unsubscribeMdrn)
      )
      .subscribe((dataRecieve) => {
        switch (dataRecieve.origin) {
          case 'infoSessionClient':
            if (!this._utilS.isEmpty(dataRecieve.data)) {
              this.clientName = dataRecieve.data.cliente;
              this.maskedContract = this._utilS.mskContract(dataRecieve.data.contrato)  
            }
            break;
        }
      })



    // Subscribe to navigation data
    this._navigationService.navigation$
      .pipe(takeUntil(this._unsubscribeMdrn))
      .subscribe((navigation: Navigation) => {
        this.navigation = navigation;
      });

    // Subscribe to media changes
    this._mediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeMdrn))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes("md");
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeMdrn.next(true);
    this._unsubscribeMdrn.complete();
    this._unsubscribeMdrn?.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation =
      this._bxNavigationService.getComponent<BxVerticalNavigationComponent>(
        name
      );

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
